function middlewareFactory(errorHandler) {
  return function middlewareStore(store) {
    return function middlewareNext(next) {
      return function middlewareAction(action) {
        try {
          return next(action);
        } catch (error) {
          errorHandler(error, store.getState);
          return error;
        }
      };
    };
  };
}

module.exports = middlewareFactory;



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/redux-catch/index.js
 ** module id = 3079
 ** module chunks = 0
 **/